import Arrow from 'blocks/Arrow/Arrow';
import ds from 'designsystem';

const LanguageArrow = Arrow.extend`
  display: inline-block;
  width: calc(${ds.get('metrics.xs')} * 2/3);
  height: calc(${ds.get('metrics.xs')} * 2/3);
  border-bottom-width: 1px;
  border-right-width: 1px;
  margin-left: 10px;
  margin-bottom: 4px;
  user-select: none;
`;

export default LanguageArrow;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/Languages/LanguageArrow.jsx